import axios, { Method, ResponseType } from "axios";
import React from "react";
import { ususarioStore } from "../stores/usuarioStore";

interface IConfig {
  method: Method;
  headers?: any;
  data?: any;
  params?: any;
  responseType?: ResponseType;
}

export interface IProps {
  url: string;
  basePath?: string;
  config?: IConfig;
  files?: [];
}

const useFetch = () => {
  const { usuario, setUsuario } = ususarioStore();
  const controllerRef = React.useRef(new AbortController());

  React.useEffect(() => {
    return () => {
      controllerRef.current.abort();
    };
  }, []);

  const call = async (data: IProps, abort: boolean = true) => {
    // Cancelar la señal anterior si existe
    if (abort) {
      controllerRef.current.abort();
      controllerRef.current = new AbortController();
    }
    const baseUrl =
      data.basePath || (process.env.REACT_APP_MODE === 'PRODUCTION' ? process.env.REACT_APP_CONROL_MEDICO_BASE_URL_PROD : process.env.REACT_APP_CONROL_MEDICO_BASE_URL_DEV);

    return axios({
      responseType: data.config?.responseType || "json",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${usuario?.token}`,
      },
      method: data.config?.method,
      url: `${baseUrl}/${data.url}`,
      signal: abort ? controllerRef.current.signal : undefined,
      params: data.config?.params,
      data: data.config?.data,
    })
      .then((response) => {
        return response.config.responseType === "blob"
          ? response
          : response.data;
      })
      .catch((error: any) => {
        if (axios.isCancel(error)) {
        } else if (error.response && error.response.status === 401) {
          setUsuario({
            token: null,
            SUCURSAL: [],
          });
        }
        return error;
      });
  };

  return { call };
};

export default useFetch;
